/**
 * Creatives Service
 * Сервис для работы с креативами
 */

import api from './api';

export const creativesService = {
  // Получить все креативы
  getAll: async (params = {}) => {
    const response = await api.get('creatives/', { params });
    return response.data;
  },

  // Получить креатив по ERID
  getByErid: async (erid) => {
    const response = await api.get(`creatives/${erid}`);
    return response.data;
  },

  // Создать креатив
  create: async (data) => {
    const response = await api.post('creatives/', data);
    return response.data;
  },

  // Обновить креатив
  update: async (erid, data) => {
    const response = await api.put(`creatives/${erid}`, data);
    return response.data;
  },

  // Удалить креатив
  delete: async (erid) => {
    const response = await api.delete(`creatives/${erid}`);
    return response.data;
  },

  // Синхронизировать с VK ORD
  sync: async () => {
    const response = await api.post('creatives/sync');
    return response.data;
  }
};
